module.exports = __webpack_public_path__ + "static/media/Totaljobs.3182c41a.svg";